import React from 'react';
import Marquee from 'react-fast-marquee';

const BRANDS = [
  'Axis Bank', 'D’Decor', 'De Beers', 'SK-II',
  'Flipkart', 'Ambipur', 'Braun Beauty', 'Rare Rabbit', 'Jaquar', 'Oaksmith',
  'Wellbeing Nutrition', 'vivo', 'Netflix', 'Pearlpet', 'FOREO', 'The Moms Co.',
  'Sweet Truth', 'Trident', 'EatSure', 'Behrouz Biryani', 'Almond Board of California',
  'GSK', 'CRED', 'Uber', 'Bumble', 'RAW Pressery', 'Redmi', 'Tupperware',
  'Captain Zack', 'Hayu', 'AlchemLife', 'Horlicks', 'Baby Dove', 'Dabur Lal Tail',
  'Urban Company', 'VAHDAM', 'Chupps', 'MamyPoko', 'Taj Mahal Tea', 'Amazon',
  'LuvLap', 'Fisher-Price', 'The Man Company', 'Simba', 'Emma', 'MobiKwik',
  'Himalaya', 'Times of India', 'Deborah Milano', 'Make Up For Ever', 'HDFC Bank',
  'ASICS', 'Just Herbs', 'Healthy Cravings', 'Power Gummies', 'Hopscotch', 'Dyson',
  'MasterClean', 'Kingfisher', 'L’Oréal', 'BOX8', 'Pfizer', 'Stellar School',
  'Love Beauty & Planet', 'Orimii', 'Clinic Plus', 'Yogutty', 'LoveChild by Masaba',
  'Lenskart', 'Maddox', 'Flo', 'boAt', 'Slurrp Farm', 'FirstCry', 'Nykaa', 'Hotstar',
  'Indriya', 'Sebamed', 'LEGO', 'Figaro Baby', 'OZiva', 'CureSkin', 'Lloyd',
  'Michael Kors', 'CaratLane', 'Parachute Baby', 'Eureka Forbes', 'Goibibo',
];

export default function BrandTicker({ tone = 'light' }) {
  const dark = tone === 'dark';
  return (
    <div
      data-testid="brand-ticker"
      className={`${dark ? 'bg-[#1a3a2e] text-[#f5f1e8]' : 'bg-[#f5f1e8] text-[#1a3a2e]'} border-y ${
        dark ? 'border-[#f5f1e8]/10' : 'border-[#1a3a2e]/10'
      } py-8`}
    >
      <Marquee gradient={false} speed={45} pauseOnHover>
        {BRANDS.concat(BRANDS).map((b, i) => (
          <span
            key={`${b}-${i}`}
            className="font-serif text-2xl md:text-3xl italic mx-12 opacity-80 whitespace-nowrap"
          >
            {b}
          </span>
        ))}
      </Marquee>
    </div>
  );
}
